<br><br>
<div class="row justify-content-center">

    <button class="btn btn-primary" (click)="onClickYearDown()">
        << Année précédente</button>
            <button class="btn btn-primary" (click)="onClickYearUp()">Année suivante >></button>

            <br>

            <ng-container *ngIf="ventes">
                <div class="table-responsive">
                    <table class="table table-striped table-sm table-hover">
                        <thead>
                            <tr>
                                <th scope="col"></th>
                                <ng-container *ngFor="let date of tDateHeader">
                                    <th scope="col">{{ date }}</th>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="tJour">
                                <tr *ngFor="let j of tJour">
                                    <th scope="row">{{ j + 1 }}</th>
                                   
                                        <ng-container *ngFor="let d of tYearMonth">
                                            <ng-container *ngIf="ventes[d.year]">
                                                <td [class.bestofmonth]="ventes[d.year][d.month].bestOfMonth == ventes[d.year][d.month].ventes[j]">{{ ventes[d.year][d.month].ventes[j] }}</td>
                                            </ng-container>
                                        </ng-container>
                             
                                </tr>
                            </ng-container>
                            <ng-container *ngIf="ventes">
                                <tr class="salestotal">
                                    <th scope="row">Total</th>
                                    <ng-container *ngFor="let somme of total">
                                        <td>{{ somme }}</td>
                                    </ng-container>
                                </tr>

                                <tr>
                                    <th scope="row">Moy.</th>
                                    <ng-container *ngFor="let moy of moyenne">
                                        <td>{{ moy }}</td>
                                    </ng-container>
                                </tr>

                                <tr>
                                    <th scope="row">CA</th>
                                    <ng-container *ngFor="let ca of sommeCA">
                                        <td>{{ ca }}</td>
                                    </ng-container>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </ng-container>

            <ng-container *ngIf="totalVentes">
                <table class="table table-striped table-sm col-sm-4">
                    <thead>
                        <th scope="col">Année</th>
                        <th scope="col">Ventes</th>
                        <th scope="col">Pizzas</th>
                        <th scope="col">Froides</th>
                        <th scope="col">CA</th>
                    </thead>
                    <tbody>

                        <ng-container *ngFor="let vente of totalVentes">
                            <tr>
                                <th scope="row">{{vente.year}}</th>
                                <td>{{ vente.ventes_count }}</td>
                                <td>{{ vente.pizzas_vendues_count }}</td>
                                <td>{{ vente.pizzas_vendues_froides_count }}</td>
                                <td>{{ vente.CA_TTC }} €</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </ng-container>


</div>